import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Col, Row, Button, Card } from 'react-bootstrap';
import '../../../assets/css/Recruiter.css';
import '../../../assets/css/Form.css';
import { Header, Footer } from '../../Container';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { jobRequest } from '../../../store/jobOpportunities/async-actions';
import moment from 'moment';
import { Multiselect } from 'multiselect-react-dropdown';
import { ReqPost, ReqGet } from '../../../config/Requests';

function JobDetailsRecruiter(props) {
	const [data, setData] = useState({});
	const startDate = moment(data.start_date).format('MM-DD-YYYY');
	const endDate = moment(data.end_date).format('MM-DD-YYYY');

	const getIdFromPath = pathName => pathName.split('/').reverse()[0];

	const jobListData = useSelector(state => state.data.jobList);
	const id = useSelector(state =>
		getIdFromPath(state.router.location.pathname)
	);
	const error = useSelector(state => state.data.errorMessage);

	useEffect(() => {
		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				setData(data?.data);
			})
			.catch(err => {
				console.log(err.message);
			});
		// if (jobListData === undefined || jobListData.length === 0) { props.jobList(); }
		// console.log(jobListData, id);
		// if (jobListData && id) {
		// 	const index = jobListData.findIndex(item => item.id === parseInt(id))
		// 	if (index === -1) {
		// 		return
		// 	}
		// 	setData(jobListData[index])
		// }
	}, [jobListData, id]);
	if (error) {
		return <p>Jobs can't be loaded</p>;
	}
	return (
		<Container fluid='true'>
			<Header type='recruiter' />
			<Container fluid='md'>
				<Row className='justify-content-md-left mt-3 mb-3'>
					<Col className='p-0'>
						<Link to='/'>
							<Button variant='outline-primary btn-back-main'>Back</Button>
						</Link>
					</Col>
				</Row>
				{data && (
					<Row>
						<Col key={data.user_id} className='p-0'>
							<Card className='mt-3 mb-2 job-view'>
								<Card.Body>
									<Card.Text className='text-job-orange'>
										Client ID #: {data.user_id}
									</Card.Text>
									<Card.Title className='text-primary small p-1 font-weight-bolder'>
										{data.title}
									</Card.Title>
									<Card.Text className='text-job-orange'>
										Sales Engineer | Requires Travel | Remote
									</Card.Text>
									<Card.Text className='text-job-orange'>
										Requirements
									</Card.Text>
									<Card.Text className='text-job-orange'>General</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<p>{data.description}</p>
									</Card.Text>

									<Card.Text className='text-job-orange'>
										Specific qualifications
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<p>{data.specific_qualification}</p>
									</Card.Text>

									<Card.Text className='text-job-orange'>Destination</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										In state:
										{data.destination}
									</Card.Text>

									<Card.Text className='text-job-orange'>Tags</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<Multiselect
											options={data.tags}
											placeholder=''
											displayValue='display_name'
											selectedValues={data.tags}
											disable='true'
											style={{
												chips: { background: 'blue' },
												searchBox: { border: 'hidden', background: 'white' },
												closeIcon: { fontSize: '0px' },
											}}
										/>
									</Card.Text>

									<Card.Text className='text-job-orange'>
										Duration of travel
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.travel_duration}
									</Card.Text>

									<Card.Text className='text-job-orange'>
										Security clearance level
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.security_level}
									</Card.Text>

									<Card.Text className='text-job-orange'>
										Pay rate range
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.start_pay_range}-{data.end_pay_range} per month
									</Card.Text>

									<Card.Text className='text-job-orange'>Dates</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<span>
											Start Date: &nbsp;
											{startDate}
										</span>
										<br />
										<span>
											End date: &nbsp;
											{endDate}
										</span>
									</Card.Text>

									<Card.Text className='text-job-orange'>Location</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.destination}
									</Card.Text>

									<Card.Text className='text-job-orange'>Job Type</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.job_type == 'fullTime' && 'Full Time'}{' '}
										{data.job_type == 'halfTime' && 'Half Time'}{' '}
										{data.job_type == 'both' && 'Full & half time'}
									</Card.Text>
								</Card.Body>
							</Card>
						</Col>
					</Row>
				)}
			</Container>
			<Footer />
		</Container>
	);
}

// const mapDispatchToProps = dispatch => {
// 	return {
// 		jobList: () => dispatch(jobRequest()),
// 	};
// };
export default JobDetailsRecruiter;
